import React from 'react';

import { cn } from '@/lib/utils';

import { ActivityIcon } from './ActivityIcon';
import { ActivityTimestamp } from './ActivityTimestamp';
import { ActivityTitle } from './ActivityTitle';
import { UserAvatar } from './UserAvatar';

export interface ActivityHeaderProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  timestamp: Date | string;
  user?: {
    name: string;
    avatarUrl?: string;
    avatarIcon?: React.ReactNode;
  };
  className?: string;
}

export const ActivityHeader: React.FC<ActivityHeaderProps> = ({
  icon,
  title,
  timestamp,
  user,
  className,
}) => {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <ActivityIcon icon={icon} />
      <div className="flex min-w-0 flex-1 items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <ActivityTitle>{title}</ActivityTitle>
          <span className="text-gray-400">•</span>
          <ActivityTimestamp timestamp={timestamp} />
        </div>
        {user && (
          <div className="flex items-center gap-2">
            <UserAvatar
              name={user.name}
              url={user.avatarUrl}
              icon={user.avatarIcon}
              size="sm"
            />
            <span className="text-sm text-gray-600">{user.name}</span>
          </div>
        )}
      </div>
    </div>
  );
};
